import AuthService from "../../AuthService";
const subMenu = {
  getSubMenu(page) {
    return AuthService.get("/menu/sub-menus?page=" + page);
  },
  showSubMenu(id) {
    return AuthService.get("/menu/sub-menus/" + id);
  },
  createSubMenu(data) {
    return AuthService.post("/menu/sub-menus", data);
  },
  updateSubMenu(id, data) {
    return AuthService.put("/menu/sub-menus/" + id, data);
  },
  deleteSubMenu(id) {
    return AuthService.delete("/menu/sub-menus/" + id);
  },
  getSubMenuFromMenuId(id) {
    return AuthService.get(`/menu/menu/sub-menus/${id}`);
  }
};
export default subMenu;
